<app-loader [isLoading]="loading"></app-loader>
@if(isMobile){
    <div class="bar-wrap">
        <hr class="bar">
    </div>
}
<header>
    <h2>Visit - {{memName}} ({{data.memKey.SL_NO}})</h2>
    <div class="btn-grp">
        <div class="toggle">
            <button [class.active]="activeView==='Add details'" type="button" (click)="activeView='Add details'">
                @if (data.memKey.visit_count<3) {
                    {{(visited)?'Edit':'Add'}}
                }
                @else {
                    {{(visited)?'Edit details':'Add details'}}
                }
            </button>
            <button [class.active]="activeView==='Visit history'" type="button" (click)="activeView='Visit history'">
                {{(data.memKey.visit_count<3)?'History':'Visit history'}}
            </button>
        </div>
        @if (!isMobile) {
            <button type="button" (click)="dialogRef.close()">
                <span></span>
            </button>
        }
    </div>
</header>

@if(activeView==='Add details'){
    <nav>
        @for(step of steps;track step){
            <div>
                <div [class.active]="allowedSteps.includes($index)" 
                (click)="allowStep($index,true)"><!--(stepSl!==2&&$index===3)?allowStep($index,false):-->
                {{$index+1}}
                </div>
                <span class="stepper-title" [class.active]="allowedSteps.includes($index)" 
                (click)="allowStep($index,true)"><!--(stepSl!==2&&$index===3)?allowStep($index,false):-->
                {{step}}
                </span>
            </div>
            @if(!$last){
                <span class="stepper-right"></span>
            }
        }
    </nav>
    
    @switch (stepSl) {
        @case (0) {
            <app-verify-fc [dpName]="dpName" [selectedMemKey]="selectedMemKey" [fcMembers]="fcMembers" [familyCode]="memDetails.familyCode"
            (familyMembers)="fcMembers=$event" (selectedMemberKey)="selectedMemKey=$event" 
            (step)="allowStep($event)">
            </app-verify-fc>
        }
        <!-- @case (1) {
            <app-dikshit-details [memDetails]="memDetails" [ritwik]="dpRitwikName"
            (memberDetails)="memDetails=$event" 
            (step)="allowStep($event)">
            </app-dikshit-details>
        }
        @case (2) {
            <app-dikshit-address [presAddress]="presAddress" [permAddress]="permAddress"
            (permAddEmitter)="permAddress=$event" (presAddEmitter)="presAddress=$event"
            (step)="allowStep($event)">
            </app-dikshit-address>
        } -->
        @case (1) {
            <app-comments [visit]="visit" [memDetails]="memDetails" [addressDetails]="visitAddress"
            [flow]="flow" [visited]="visited" [rowData]="data.memKey"
            (visitEmitter)="visit=$event" (memDetails)="assignDetails($event)" (addressEmitter)="assignAddress($event)"
            (choiceEmitter)="choose($event)" (step)="allowStep($event)">
            </app-comments>
        }
    }
}
@else {
    <app-visit-history [visitHistoryDetails]="visitHistoryDetails" [canAccessVisitContact]="data.data.canAccessVisitContact"></app-visit-history>   
}
